import React from 'react';
import { MapContainer, TileLayer,Marker,Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import L from 'leaflet';


const BaghdadMap = () => {
  const customIcon = new L.Icon({
    iconUrl: 'https://leafletjs.com/examples/custom-icons/leaf-red.png',
    iconSize: [38, 95],
    iconAnchor: [22, 94],
    popupAnchor: [-3, -76],
  });
    const center = [33.317315370259806, 44.36828293793784]; // Default map center (latitude, longitude)
  const locations = [
    
    { name: 'عوينات كولدن', position: [33.30186868485942, 44.423150764360734] },
    { name: 'عوينات كولدن ', position: [33.25686657608663, 44.355298271164095] },
      { name: 'عوينات كولدن ', position: [33.37728394984719, 44.37276044460546] }




    








  ];
  return (
    <MapContainer center={center} zoom={11} style={{ height: '100vh', width: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
      />
      {locations.map((loc, idx) => (
        <Marker key={idx} position={loc.position} icon={customIcon }>
          <Popup>{loc.name}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default BaghdadMap;
